/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardBatchRequest {
    getFixupPrototypeFunction() { return ComplianceStandardBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardBatchRequest>): ComplianceStandardBatchRequest {
        let obj = Object.assign(new ComplianceStandardBatchRequest(), model);
        ComplianceStandardBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardBatchRequest>): ComplianceStandardBatchRequest {
        if (!model) return null;
        return ComplianceStandardBatchRequest.newInstance(<ComplianceStandardBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardBatchRequest) {
        if (!obj) return;

        models.ComplianceStandardBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardBatchRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of compliance standard URIs
     */
    compliance_standard_uris: Array<string>;

    /**
     * List of compliance standard IDs
     */
    compliance_standard_ids: Array<string>;

}
